var nsfCommon = {
    init: function () {
        this._initToTopEvent();
        this._stickyAnnouncement();
        this._initProductTabs();
    },

    navTo: function (el) {
        let toTopEl = $(el);

        if (toTopEl.length <= 0) {
            toTopEl = $('body');
        }

        toTopEl.scrollIntoView({ behavior: 'smooth' });
    },

    _initToTopEvent: function () {
        $(document).on('scroll', function () {
            if ($(this).scrollTop() >= 150) {
                $('[data-nsf="scroll-top"]').addClass('active');
            } else {
                $('[data-nsf="scroll-top"]').removeClass('active');
            }
        });
    },

    _stickyAnnouncement: function () {
        let $nav = $('#nav');
        let $header = $('header');
        
        let mo = new MutationObserver(function (mutations) {
            mutations.forEach(function (m) {
                let $header = $(m.target);
                let $announcement = $('[data-section-type="announcement-section"]');

                if ($announcement.length <= 0) {
                    return;
                }

                let $jsClearEl = $('#shopify-section-header .js-clear-element');
                if ($header.hasClass('header--sticky') || $header.hasClass('navigation--sticky')) {
                    $header.css({ 'top': $announcement.outerHeight(true) + 'px' });
                    $announcement.addClass('announcement--sticky');
                    $jsClearEl.css({'margin-top': $jsClearEl.outerHeight(true) + $announcement.outerHeight(true) + 'px'});
                } else {
                    $header.css({'top': ''});
                    $announcement.removeClass('announcement--sticky');
                    $jsClearEl.css({'margin-top': $jsClearEl.outerHeight(true) + 'px'});
                }
            });
        })

        mo.observe($header[0], {
            attributes: true
        });
        mo.observe($nav[0], {
            attributes: true
        })
    },

    _initProductTabs: function () {
        let width = $(window).width();
        
        let observer = new MutationObserver(function(mutations) {
            mutations.forEach(function (m) {
                if ($(m.target).is(':visible') && width >= 768) {
                    $(m.target).find('.nano').nanoScroller();
                }
            });
        });
        
        $('.tabbed__product-content').each(function () {
            $(this).find('.nano').nanoScroller();
            
            observer.observe($(this)[0], {
                attributes: true
            });
        })
    }
}

var headerSearch = {
    ajaxReq: null,

    init: function () {
        this._bindSearchInputEvent();
        this._bindCloseSearchResultEvent();
    },

    _bindSearchInputEvent: function () {
        let self = this;
        $('#header-search').on('input', function () {
            self._ajaxSubmit($(this).closest('form'));
        });
    },

    _bindCloseSearchResultEvent: function () {
        $(document).on('click', function (e) {
            let $wrapper = $('[data-nsf="search-results"]');
            if (!$wrapper.is(e.target) && $wrapper.has(e.target).length === 0) {
                $wrapper.removeClass('active');
            }
        });
    },

    _ajaxSubmit: function ($form) {
        if (this.ajaxReq != null) {
            this.ajaxReq.abort();
        }

        this.ajaxReq = $.ajax({
            type: $form.attr('method'),
            url: $form.attr('action') + '?view=ajax',
            dataType: 'json',
            data: $form.serialize(),
            success: function (response) {
                let html = '';
                if (response.data.length <= 0) {
                    html = '<div class="title empty">' + response.labels.popup_empty_result + '</div>';
                } else {
                    html += '<div class="title">' + response.labels.popup_product_result + '</div>';
                    html += '<ul class="product-items">';

                    for (let p of response.data) {
                        let priceHtml = '<span class="price">' + p.price + '</span>';

                        if (p.compare_at_price.length > 0) {
                            priceHtml = '<span class="old-price">' + p.compare_at_price + '</span><span class="special-price">' + p.price + '</span>'
                        }

                        html += '<li class="product-item">';
                        html += '<a href="' + p.url + '">';
                        html += '<div class="product-image"><img src="' + p.image + '" alt="' + p.image_alt + '"></div>';
                        html += '<div class="product-info">';
                        html += '<p class="product-title">' + p.title + '</p>';
                        html += '<div class="price-wrapper">' + priceHtml + '</div>'
                        html += '</div></a></li>';
                    }

                    html += '</ul>';

                    let moreResUrl = $form.attr('action') + '?' + $form.serialize();
                    html += '<div class="more-result">';
                    html += '<a href="' + moreResUrl + '">' + response.labels.popup_more_result + ' (' + response.total_count + ')</a>';
                    html += '</div>';
                }

                $('[data-nsf="search-results"]').addClass('active').empty().html(html);
            }
        });
    },
};

var nsfSizeChart = {
    data: {},
    hideCols: [],
    ignoreTransformCols: [],
    sizeRelatedData: [],
    sizeColIndex: 0,

    init: function () {
        if (!this._enable()) {
            return;
        }

        this._initConfig();
        this._initData();
        this._initTable();
        this._bindSizeChartBtnClickEvent();
        this._initEnter();
    },

    _enable: function () {
        return $('[data-nsf="size-chart-wrapper"]').length > 0
    },

    _initConfig: function () {
        let $el = $('[data-nsf="size-chart-wrapper"]');

        if ($el.length <= 0) {
            return;
        }

        let conf = JSON.parse($el.attr('data-conf'));

        if (conf.hideCols !== undefined && conf.hideCols.length > 0) {
            this.hideCols = conf.hideCols;
        }

        if (conf.ignoreTransformCols !== undefined && conf.ignoreTransformCols.length > 0) {
            this.ignoreTransformCols = conf.ignoreTransformCols;
        }

        if (conf.sizeColIndex !== undefined) {
            this.sizeColIndex = conf.sizeColIndex;
        }
    },

    _initData: function () {
        let $dtel = $('#nsf_size_chart');

        if ($dtel.length > 0) {
            this.data = JSON.parse($dtel.html());
            this._initSizeRelatedData();
        }
    },

    _initEnter: function () {
        let self = this;
        let $sizeRelatedInfoWrapper = $('.nsf-size-related-info');

        for (const size in this.sizeRelatedData) {
            if (!this.sizeRelatedData.hasOwnProperty(size)) {
                continue;
            }

            let $el = $('[data-nsf="size-chart-swatch-' + size + '"]');

            $el.on('mouseenter', function () {
                $sizeRelatedInfoWrapper.html(self._getSizeRelatedHtml(size));
            });

            $el.on('mouseleave', function () {
                $sizeRelatedInfoWrapper.html(self._getSizeRelatedHtml(self._getSelectSize()));
            });
        }

        $sizeRelatedInfoWrapper.html(self._getSizeRelatedHtml(self._getSelectSize()));
    },

    _initSizeRelatedData: function () {
        let fmtData = {};
        for (let row of this.data.values) {
            let sizeCol = row[this.sizeColIndex];

            for (let i = 1; i < row.length; i++) {
                if (fmtData[sizeCol] === undefined) {
                    fmtData[sizeCol] = {};
                }
                fmtData[sizeCol][this.data.header[i]] = row[i];
            }
        }

        this.sizeRelatedData = fmtData;
    },

    _getSizeRelatedHtml: function (size) {
        if (this.sizeRelatedData[size] === undefined) {
            return false;
        }

        let html = '<span class="nsf-size-related title">Product Size:' + size + '</span>';

        for (const header in this.sizeRelatedData[size]) {
            if (!this.sizeRelatedData[size].hasOwnProperty(header)
                || this.hideCols.indexOf(header) !== -1) {
                continue;
            }

            let value = this.sizeRelatedData[size][header];
            if (this.ignoreTransformCols.indexOf(header) !== -1) {
                html += '<span>' + header + ':' + value + '</span>';
                continue;
            }

            html += '<span>' + header + ':' + value + 'cm/' + (value * 0.3937).toFixed(2) + 'inch</span>';
        }

        return '<p class="content">' + html + '</p>';
    },

    _getSelectSize: function () {
        return $('input[name="size"]:checked').val();
    },

    _initTable: function () {
        let ignoreIndexs = [];
        let hideIndexs = [];
        let theader = '<thead><tr>';

        for (let i = 0; i < this.data.header.length; i++) {
            // sizeColIndex 不能隐藏
            if (this.hideCols.indexOf(this.data.header[i]) !== -1 && i !== this.sizeColIndex) {
                hideIndexs.push(i);
                continue;
            }

            if (this.ignoreTransformCols.indexOf(this.data.header[i]) !== -1) {
                ignoreIndexs.push(i);
            }

            theader += '<th>' + this.data.header[i] + '</th>';
        }

        theader += '</tr></thead>';

        let tbody = '<tbody>';

        for (let row_values of this.data.values) {
            tbody += '<tr>';
            for (let i = 0; i < row_values.length; i++) {
                if (hideIndexs.indexOf(i) !== -1) {
                    continue;
                }

                let cls = 'transform-val';
                if (ignoreIndexs.indexOf(i) !== -1) {
                    cls = '';
                }
                tbody += '<td class="' + cls + '" data-val="' + row_values[i] + '">' + row_values[i] + '</td>';
            }
            tbody += '</tr>';
        }

        tbody += '</tbody>';

        $('[data-nsf="size-chart-table"]').html(theader + tbody);
    },

    _bindSizeChartBtnClickEvent: function () {
        let self = this;

        $('[data-nsf="size-chart-btn"]').on('click', function () {
            $(this).closest('div.btns').find('[data-nsf="size-chart-btn"]').removeClass('active');
            $(this).addClass('active');

            if ($(this).attr('data-val') === 'in') {
                self._toInSize();
            } else {
                self._toCmSize();
            }
        });

        $('[data-nsf="size-chart-btn"][data-val="in"]').trigger('click');
    },

    _toCmSize: function () {
        $('[data-nsf="size-chart-table"] td.transform-val').each(function () {
            $(this).html($(this).attr('data-val'));
        });
    },


    _toInSize: function () {
        $('[data-nsf="size-chart-table"] td.transform-val').each(function () {
            $(this).html(($(this).attr('data-val') * 0.3937).toFixed(2));
        });
    }
};

var nsfProductGrid = {
    ajaxWrapper: [
        'div.js-product-rec-wrapper',
    ],

    init: function () {
        this._initConfig();
        this._initDomImageSize();
        this._initAjaxImageSIze();
        this._initRecentlyViewQuickViewEvent();
    },

    _initConfig: function () {
        let $el = $('[data-nsf="prod-grid"]');

        if ($el.length > 0) {
            let conf = JSON.parse($el.attr('data-conf'));
            this.ajaxWrapper = conf.ajaxWrapper;
        }
    },

    _initDomImageSize: function () {
        this._initGridProductImageSize($('#main-collection-product-grid'));
        this._initGridProductImageSize($('.featured__collection'));
        this._initGridProductImageSize($('.mini-cart__container'))
    },

    _initAjaxImageSIze: function () {
        let self = this;

        let mo = new MutationObserver(function (mutations) {
            mutations.forEach(function (m) {
                for (let node of m.addedNodes) {
                    self._initGridProductImageSize($(node));
                }
            })
        })

        for (const wrapper of this.ajaxWrapper) {
            if (wrapper.length <= 0) {
                continue;
            }

            $(wrapper).each(function () {
                mo.observe($(this)[0], {
                    childList: true
                });
            })
        }
    },

    _initGridProductImageSize: function ($el) {
        if ($el === undefined) {
            $el = $('body');
        }

        let $imageWrappers = $el.find('.prod-image .reveal .box-ratio')

        let maxHeight = 0;
        $imageWrappers.each(function () {
            maxHeight = Math.max(maxHeight, $(this).outerHeight());
        });

        if (maxHeight > 0) {
            $imageWrappers.each(function () {
                $(this).css('padding-bottom', maxHeight + 'px');
            });
        }
    },
    
    _initRecentlyViewQuickViewEvent: function () {
        let mo = new MutationObserver(function (mutations) {
            mutations.forEach(function (m) {
                for (let node of m.addedNodes) {
                    $(node).find('.js-quickview-trigger').on('click', function (event) {
                        event.preventDefault();

                        // Init modal
                        WAU.Modal.init("quickview");

                        // Get template
                        let productUrl = Shopify.theme.quickview.cleanUrl(this.dataset.productUrl, 'variant');
                        Shopify.theme.quickview.getTemplate(productUrl);
                    })
                }
            })
        })
        
        $('#recently-viewed-products').each(function () {
            mo.observe($(this)[0], {
                childList: true
            })
        });
    }
}

var nsfProductGallery = {
    init: function () {
        this._initFlickityViewport();
        this._initFlickityThumbnails();
    },
    
    _initFlickityViewport: function () {
        let $viewport = $('[data-product-gallery] #slider .flickity-viewport');
        
        if ($viewport.length <= 0) {
            return;
        }
        
        let minHeight = 0;
        
        $viewport.find('.carousel-cell .product-media-container').each(function () {
            minHeight = Math.max(minHeight, $(this).height());
        });
        
        $viewport.find('.carousel-cell .product-media-container').each(function () {
            $(this).css(
                {
                    'min-height': minHeight,
                    'display': 'flex',
                    'justify-content': 'center',
                    'align-items': 'center',
                    'background': '#fff',
                    'border': '1px solid #efefef'
                }
            );
        });
    },
    
    _initFlickityThumbnails: function () {
        let $viewport = $('[data-product-gallery] #thumbnails .flickity-viewport');

        if ($viewport.length <= 0) {
            return;
        }
        
        let minHeight = 0;
        
        $viewport.find('.image-thumbnail > div').each(function () {
            minHeight = Math.max(minHeight, $(this).height());
        });

        $viewport.find('.image-thumbnail > div').each(function () {
            $(this).css(
                {
                    'min-height': minHeight, 
                    'display': 'flex', 
                    'justify-content': 'center', 
                    'align-items': 'center',
                    'background': '#fff',
                    'border': '1px solid #efefef'
                }
            );
        });
    }
}

var nsfShoppingCart = {
    init: function () {
        this._initToLastColBtn();
        // this._initCartPageOnAjaxCartFormLoad();
        this._initContinueShoppingBtn();
        this._initClearShoppingCartBtn();
    },

    _initToLastColBtn: function () {
        let self = this;
        $('[data-nsf="to-last-col"]').on('click', function () {
            self._toLastCol();
        });
    },

    _toLastCol: function () {
        let lastCol = localStorage.getItem('__nsf_last_col');

        if (lastCol) {
            window.location.href = lastCol;
            return;
        }

        if ($(this).closest('.mini-cart__container')) {
            $(this).closest('.mini-cart__container').find('button.js-slideout-close').trigger('click');
        } else {
            window.location.href = '/';
        }
    },


    _initCartPageOnAjaxCartFormLoad: function () {
        let self = this;

        let mo = new MutationObserver(function (mutations) {
            mutations.forEach(function (m) {
                if (m.addedNodes <= 0) {
                    return;
                }

                for (const node of m.addedNodes) {
                    let $node = $(node);

                    if (!$node.is('form.ajax-cart__cart-form.js-cart-form')) {
                        continue;
                    }

                    let $summaryNode = $node.find('.ajax-cart__summary-wrapper.js-cart-summary');

                    if ($summaryNode.length <= 0) {
                        continue;
                    }

                    $(m.target).css('min-height', $summaryNode.outerHeight());

                    if ($summaryNode.find('.nsf-block.block-calc-shipping').length > 0) {
                        self._initCartPageOnToggleShippingCalculator($summaryNode);
                    }

                    // 绑定按钮事件
                    self._initToLastColBtn();
                    self._initContinueShoppingBtn();
                    self._initClearShoppingCartBtn();
                    self._fixSpecialOfferMultiCouponCode();
                }
            });
        });

        $('.cart-page .ajax-cart__form-wrapper.js-ajax-cart-content').each(function () {
            mo.observe($(this)[0], {
                childList: true
            });
        })
    },

    _initCartPageOnToggleShippingCalculator: function ($node) {
        let $formWrapper = $('.cart-page .ajax-cart__form-wrapper.js-ajax-cart-content');

        let mo = new MutationObserver(function (mutations) {
            mutations.forEach(function (m) {
                if (m.attributeName !== 'class') {
                    return;
                }
                $formWrapper.css('min-height', $node.outerHeight());
            });
        });

        $node.find('.js-cart-accordion > li').each(function () {
            mo.observe($(this)[0], {
                attributes: true
            });
        })
    },
    
    _initContinueShoppingBtn: function () {
        let self = this;
        $('[data-nsf="btn-continue-shopping"]').on('click', function (e) {
            self._toLastCol();
        });
    },
    
    _initClearShoppingCartBtn: function () {
        $('[data-nsf="btn-clear-cart"]').on('click', function (e) {
            e.preventDefault();
            Shopify.theme.cart.clearItems();
            window.location.reload();
        });
    },

    _fixSpecialOfferMultiCouponCode: function () {
        let mo = new MutationObserver(function (mutations) {
            mutations.forEach(function (m) {
                for (let node of m.addedNodes) {
                    $(node).find('.saso-use-discount-code-cart-apply').on('click', function (e) {
                        let $container = $(this).closest('.saso-use-discount-code-cart-container');
                        let $input = $container.find('input.saso-use-discount-code-cart-code');
                        $('input.saso-use-discount-code-cart-code').val($input.val());
                    });
                }
            })
        })

        $('.nsf-cart-coupon .saso-summary').each(function () {
            mo.observe($(this)[0], {
                childList: true
            });
        });
    }
}

var nsfModal = {
    scrollTop: 0,
    freezeScrollTop: 0,
    
    init: function () {
        this._initModal();
        this._initWindowScrollEvent();
    },
    
    _initModal: function () {
        let self = this;
        let $modalTrigger = $('[data-nsf="modal-trigger"]');

        $modalTrigger.each(function () {
            let target = $(this).attr('data-target');
            let conf = JSON.parse($(this).attr('data-conf'));
            
            if (conf.title === undefined) {
                console.warn('nsf modal [' + target + '] configuration error.');
                return;
            }
            
            let $modalContent = $('[data-modal="' + target + '"]');
            if ($modalContent.length !== 1) {
                console.warn('nsf modal [' + target + '] content error.')
            }
            
            let $modal = self._createModal($modalContent, conf);

            $(this).on('click', function () {
                $modal.addClass('active');
                self._lockWindow();
            });
        });
    },
    
    _createModal: function ($modalContent, conf) {
        let self = this;
        let $modal = $(this._getTemplate());
        
        $modal.find('.modal-header h3.title').text(conf.title);
        $modal.find('.modal-content').html($modalContent.html());
        $modal.addClass($modalContent.attr('data-modal'));
        
        $modalContent.empty();
        
        $modal.find('.modal-close').on('click', function () {
            $modal.removeClass('active');
            self._unlockWindow();
        });
        
        $('body').append($modal[0]);
        return $modal;
    },
    
    _getTemplate: function () {
        return '<div class="nsf-modal-container">'
            + '<div class="modal-header"><h3 class="title"></h3><span class="nsf-btn modal-close"></span></div>'
            + '<div class="modal-content"></div>'
            + '</div>';
    },

    _initWindowScrollEvent: function () {
        let self = this;
        
        self.scrollTop = $(document).scrollTop();
        
        $(document).on('scroll', function () {
            self.scrollTop = $(document).scrollTop();
        });
    },
    
    _lockWindow: function () {
        let self = this;
        let $body = $('body');
        self.freezeScrollTop = self.scrollTop;
        
        $('#shopify-section-header [data-sticky-class]').each(function () {
            if ($(this).hasClass($(this).attr('data-sticky-class'))) {
                self.freezeScrollTop -= $(this).outerHeight(true);
                
                $(this).css({'--nsf-lock-pos-top': $(this).position().top + 'px'})
                $(this).addClass('__nsf-lock-sticky');
            }
        });

        let $announcementBar = $body.find('.announcement__bar-section');
        
        if ($announcementBar.hasClass('announcement--sticky')) {
            self.freezeScrollTop -= $announcementBar.outerHeight(true);

            $announcementBar.css({'--nsf-lock-pos-top': $announcementBar.position().top + 'px'})
            $announcementBar.addClass('__nsf-lock-sticky');
        }

        $body.css({'--nsf-lock-pos-top': -(self.freezeScrollTop) + 'px'});
        $body.addClass('nsf-modal-active');
    },
    
    _unlockWindow: function () {
        $body = $('body');
        $body.removeClass('nsf-modal-active');
        $body.find('.__nsf-lock-sticky').removeClass('__nsf-lock-sticky');
        $(document).scrollTop(this.freezeScrollTop);
    }
}

var nsfQuickShop = {
    ajaxWrapper: [
        'div.js-product-rec-wrapper',
    ],

    init: function () {
        this._initQuickShopOnLoad();
        this._initQuickShopOnAjaxLoad();
        this._initQuickShopOnRecentViewLoad();
    },

    _initQuickShopOnLoad: function () {
        this._initQuickShop($('body'));
    },

    _initQuickShopOnAjaxLoad: function () {
        let self = this;

        let mo = new MutationObserver(function (mutations) {
            mutations.forEach(function (m) {
                for (let node of m.addedNodes) {
                    self._initQuickShop($(node));
                }
            })
        })

        for (const wrapper of this.ajaxWrapper) {
            if (wrapper.length <= 0) {
                continue;
            }

            $(wrapper).each(function () {
                mo.observe($(this)[0], {
                    childList: true
                });
            })
        }
    },

    _initQuickShopOnRecentViewLoad: function () {
        let self = this;

        let mo = new MutationObserver(function (mutations) {
            mutations.forEach(function (m) {
                for (let node of m.addedNodes) {
                    $(node).find('.js-quickview-trigger').on('click', function (event) {
                        event.preventDefault();

                        // Init modal
                        WAU.Modal.init("quickview");

                        // Get template
                        let productUrl = Shopify.theme.quickview.cleanUrl(this.dataset.productUrl, 'variant');
                        Shopify.theme.quickview.getTemplate(productUrl);
                    })

                    self._initQuickShop($(node));
                }

            })
        })

        $('#recently-viewed-products').each(function () {
            mo.observe($(this)[0], {
                childList: true
            })
        });
    },
    
    _initQuickShop: function ($el) {
        let self = this;
        $el.find('[data-nsf="quick-shop"]').each(function () {
            let $wrapper = $(this).find('[data-nsf="qs-wrapper"]');
            let product = JSON.parse($(this).find('[data-nsf="qs-product-data"]').html())
            
            self._buildQuickShopHtml($wrapper, product);
            
            self._bindOpenQuickShopEvent($wrapper.find('[data-nsf="qs-open"]'));
            self._bindCloseQuickShopEvent($wrapper.find('[data-nsf="qs-close"]'));
            self._bindSwatchOptionOnClickEvent($wrapper.find('li.qs-swatch-option-value'));
            self._bindAddToCartEvent($wrapper.find('[data-nsf="qs-atc"]'));

            self._bindOpenQuickShopModalEvent($wrapper.find('[data-nsf="qs-modal"]'));

            self._autoSelectSwatchOption($wrapper, product);
        });
    },
    
    _buildQuickShopHtml: function ($wrapper, product) {
        let html = '<button class="qs-btn qs-open" data-nsf="qs-open">Quick Shop</button>'
            + '<button class="qs-btn qs-open qs-open-modal" data-nsf="qs-modal">Quick Shop</button>'
            + '<div class="qs-popup-wrapper">'
            + '<span class="qs-btn qs-close" data-nsf="qs-close">x</span>'
            + this._buildSwatchHtml(product)
            + this._buildQuickShopForm()
            + '</div>';
        
        $wrapper.html(html);
    },
    
    _buildSwatchHtml: function (product) {
        let html = '<div class="qs-swatches">';

        for(let index in product.options) {
            if (!product.options.hasOwnProperty(index)) {
                continue;
            }
            let option = product.options[index];
            let optionHandle = option.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');

            html += '<div class="qs-swatches-option ' + optionHandle + '">';
            html += '<label class="qs-swatch-option-name">' + option + '</label>';
            html += '<ul class="qs-swatch-option-values">'

            let values = this._collectOptionValues(index, product.variants);
            
            for (let value of values) {
                let availableClass = '';

                if (!this._isSwatchOptionValueAvailable(index, value, product.variants)) {
                    availableClass = ' un-available';
                }
                
                let bgStyle = '';
                if (optionHandle.indexOf('color') !== -1) {
                    bgStyle = this._getColorOptionBackgroundStyle(index, value, product.variants);
                }

                html += '<li class="qs-swatch-option-value' + availableClass + '" data-option-index="' + index + '" data-option-value="' + value + '">';
                html += '<span style="' + bgStyle + '">' + value + '</span>';
                html += '</li>';
            }

            html += '</ul>';
            html += '</div>';
        }

        html += '</div>';
        
        return html;
    },
    
    _buildQuickShopForm: function () {
        return '<form data-nsf="qs-form" method="post" action="/cart/add">'
            + '<input type="hidden" name="id" value="">'
            + '<input type="hidden" name="quantity" value="1">'
            + '<input type="hidden" name="form_type" value="product">'
            + '<input type="hidden" name="utf8" value="✓">'
            + '<button class="qs-btn qs-atc js-ajax-submit" data-nsf="qs-atc">Add to cart</button>'
            + '</form>'
    },
    
    _collectOptionValues: function (optionIndex, variants) {
        let fmtData = [];
        let fieldName = 'option' + (parseInt(optionIndex) + 1);

        for (let variant of variants) {
            if (fmtData.indexOf(variant[fieldName]) !== -1) {
                continue;
            }
            
            fmtData.push(variant[fieldName]);
        }
        
        return fmtData;
    },
    
    _isSwatchOptionValueAvailable: function (optionIndex, value, variants) {
        let available = false;
        
        for (let variant of variants) {
            if (!variant.available) {
                continue;
            }

            let fieldName = 'option' + (parseInt(optionIndex) + 1);
            if (variant[fieldName] === value) {
                available = true;
                break;
            }
        }
        
        return available;
    },
    
    _getColorOptionBackgroundStyle: function (optionIndex, value, variants) {
        let valueHandle = value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
        let style = 'background-color:' + valueHandle + ';';
        
        let bgUrl = '';
        let fieldName = 'option' + (parseInt(optionIndex) + 1);
        
        for (let variant of variants) {
            if (variant[fieldName] === value && variant.featured_image && variant.featured_image.src) {
                bgUrl = variant.featured_image.src;
            }
        }
        
        if (bgUrl !== '') {
            style += 'background-image: url(' + bgUrl + ');'
        }
        
        return style;
    },

    _bindOpenQuickShopEvent: function ($btn) {
        $btn.on('click', function () {
            $(this).closest('[data-nsf="quick-shop"]').addClass('active');
            $(this).closest('.nsf-prod-listing-btn-wrapper').addClass('nsf-qs-active');
        });
    },

    _bindOpenQuickShopModalEvent: function ($btn) {
        let self = this;
        $btn.on('click', function () {
            self._initQuickShopModal($(this).closest('[data-nsf="quick-shop"]'));
            $('[data-nsf="modal-trigger"][data-target="nsf-quick-shop"]').trigger('click');
        });

        $(document).on('theme:cart-update', function () {
            $('.nsf-modal-container.nsf-quick-shop .nsf-btn.modal-close').trigger('click');
        });
    },

    _initQuickShopModal: function ($qsWrapper) {
        let $modal = $('.nsf-modal-container.nsf-quick-shop');
        $modal.find('.modal-content').html($qsWrapper.find('.qs-popup-wrapper').html());

        $modal.find('[data-nsf="qs-close"]').on('click', function () {
            $modal.find('.nsf-btn.modal-close').trigger('click');
        })

        let $wrapper = $modal.find('.modal-content');
        let product = JSON.parse($qsWrapper.closest('[data-nsf="quick-shop"]').find('[data-nsf="qs-product-data"]').html());
        this._bindSwatchOptionOnClickEvent($modal.find('li.qs-swatch-option-value'), $wrapper, product);
        this._bindAddToCartEvent($modal.find('[data-nsf="qs-atc"]'), $wrapper);
    },

    _bindCloseQuickShopEvent: function ($btn) {
        $btn.on('click', function (){
            $(this).closest('[data-nsf="quick-shop"]').removeClass('active');
            $(this).closest('.nsf-prod-listing-btn-wrapper').removeClass('nsf-qs-active');
        });
    },

    _bindSwatchOptionOnClickEvent: function ($el, $wrapper = null, product = null) {
        let self = this;
        
        $el.on('click', function () {
            if ($(this).hasClass('un-available')) {
                return;
            }

            $(this).closest('.qs-swatches-option').removeClass('qs-valid-error');
            $(this).closest('ul.qs-swatch-option-values').find('li.qs-swatch-option-value').removeClass('qs-selected');
            $(this).addClass('qs-selected');


            if ($wrapper === null) {
                $wrapper = $el.closest('[data-nsf="quick-shop"]');;
            }

            if (product === null) {
                product = JSON.parse($wrapper.find('[data-nsf="qs-product-data"]').html());
            }

            let selectOption = {
                index: $(this).attr('data-option-index'),
                value: $(this).attr('data-option-value')
            }

            let selectedVariants = self._getSelectedVariants(selectOption, product.variants);

            self._updateSwatchOptionAvailableStatus($(this), selectedVariants)
            self._updateQuickShopVariant($wrapper, product);
        });
    },

    _getSelectedVariants: function (option, variants) {
        let selectedVariants = [];

        for (let variant of variants) {
            let fieldName = 'option' + (parseInt(option.index) + 1);
            if (variant[fieldName] !== option.value) {
                continue;
            }
            selectedVariants.push(variant);
        }

        return selectedVariants;
    },

    _updateSwatchOptionAvailableStatus: function ($el, selectedVariants) {
        let $swatchWrapper = $el.closest('.qs-swatches');

        $swatchWrapper.find('li.qs-swatch-option-value:not([data-option-index="' + $el.attr('data-option-index') + '"])').addClass('un-available');

        for (let variant of selectedVariants) {
            if (!variant.available) {
                continue;
            }

            for (let ov of variant.options) {
                $swatchWrapper.find('li.qs-swatch-option-value[data-option-value="' + ov + '"]').removeClass('un-available');
            }
        }
    },
    
    _updateQuickShopVariant: function ($wrapper, product) {
        let selectedOptions = [];

        $wrapper.find('li.qs-swatch-option-value.qs-selected').each(function () {
            selectedOptions.push({
                index: $(this).attr('data-option-index'),
                value: $(this).attr('data-option-value')
            });
        });
        
        if (selectedOptions.length < product.options.length) {
            return;
        }
        
        let selectVariants = [];
        
        for (let variant of product.variants) {
            let isSelected = true;
            
            for (let option of selectedOptions) {
                let fieldName = 'option' + (parseInt(option.index) + 1);
                if (variant[fieldName] !== option.value) {
                    isSelected = false
                    break;
                }
            }
            
            if (isSelected) {
                selectVariants.push(variant);
            }
        }
        
        if (selectVariants.length !== 1) {
            return;
        }

        $wrapper.find('input[name="id"]').val(selectVariants[0].id);
    },
    
    _bindAddToCartEvent: function ($btn, $wrapper = null) {
        let self = this;

        $btn.on('click', function (e) {
            e.preventDefault();

            if ($wrapper === null) {
                $wrapper = $(this).closest('[data-nsf="qs-wrapper"]')
            }

            if (!self._checkQsSwatchesSelectedStatus($wrapper)) {
                return ;
            }

            let cartConfig = $('#cart-config');
            let $qsForm = $(this).closest('[data-nsf="qs-form"]')
            
            if (cartConfig.length <= 0) {
                return false;
            }
            
            cartConfig = JSON.parse(cartConfig.html() || '{}');
            Shopify.theme.ajaxCart.addToCart($qsForm[0], $qsForm[0], cartConfig);
        });
    },
    
    _checkQsSwatchesSelectedStatus: function ($qsEl) {
        let check = true;

        $qsEl.find('.qs-swatches-option').each(function () {
            if ($(this).find('li.qs-swatch-option-value.qs-selected').length !== 1) {
                $(this).addClass('qs-valid-error');
                check = false;
            }
        });

        return check;
    },

    _autoSelectSwatchOption($qsEl, product) {
        for(let index in product.options) {
            if (!product.options.hasOwnProperty(index)) {
                continue;
            }

            let values = this._collectOptionValues(index, product.variants);
            if (values.length === 1) {
                $qsEl.find('[data-option-index="' + index + '"][data-option-value="' + values[0] + '"]').click()
            }
        }
    }
}

var nsfMobileMenu = {
    scrollTop: 0,
    freezeScrollTop: 0,
    menuPositionTop: 0,

    init: function () {
        this._initMenuTrigger();
        this._initMenuClickEvent();
        this._initWindowScrollEvent();
    },

    _initMenuTrigger: function () {
        let self = this;

        $('[data-nsf="mobile-menu-trigger"]').on('click', function () {
            $(this).toggleClass('active');

            if ($(this).hasClass('active')) {
                self.open()
            } else {
                self.close();
            }
        });

        self.menuPositionTop = 0;
        self.menuPositionTop += $('#shopify-section-header .theme-header').outerHeight(true);
        self.menuPositionTop += $('#shopify-section-announcement-bar').outerHeight(true);

        let $body = $('body');
        $body.css({'--nsf-m-menu-pos-top': self.menuPositionTop + 'px'});
        $body.css({'--nsf-m-menu-height': 'calc(100vh - ' + self.menuPositionTop + 'px)'});
    },

    open: function () {
        this._lockWindow();
        $('[data-nsf="mobile-menu"]').addClass('slideout--active');
    },

    close: function () {
        this._unlockWindow();
        $('[data-nsf="mobile-menu"]').removeClass('slideout--active');
    },

    _initWindowScrollEvent: function () {
        let self = this;

        self.scrollTop = $(document).scrollTop();

        $(document).on('scroll', function () {
            self.scrollTop = $(document).scrollTop();
        });
    },

    _lockWindow: function () {
        let self = this;
        let $body = $('body');
        self.freezeScrollTop = self.scrollTop;

        $('#shopify-section-header [data-sticky-class]').each(function () {
            if ($(this).hasClass($(this).attr('data-sticky-class'))) {
                self.freezeScrollTop -= $(this).outerHeight(true);

                $(this).css({'--nsf-lock-pos-top': $(this).position().top + 'px'})
                $(this).addClass('__nsf-lock-sticky');
            }
        });

        let $announcementBar = $body.find('.announcement__bar-section');

        if ($announcementBar.hasClass('announcement--sticky')) {
            self.freezeScrollTop -= $announcementBar.outerHeight(true);

            $announcementBar.css({'--nsf-lock-pos-top': $announcementBar.position().top + 'px'})
            $announcementBar.addClass('__nsf-lock-sticky');
        }

        $body.css({'--nsf-lock-pos-top': -(self.freezeScrollTop) + 'px'});
        $body.addClass('nsf-mobile-menu-active');
    },

    _unlockWindow: function () {
        $body = $('body');
        $body.removeClass('nsf-mobile-menu-active');
        $body.find('.__nsf-lock-sticky').removeClass('__nsf-lock-sticky');
        $(document).scrollTop(this.freezeScrollTop);
    },

    _initMenuClickEvent: function () {
        $('[data-nsf-menu]').on('click', function () {
            if (!$(this).hasClass('has_menu_items')) {
                return;
            }

            let menu = $(this).attr('data-nsf-menu');

            $('[data-nsf-menu]').removeClass('active');
            $(this).addClass('active');

            $('[data-nsf-parent-menu]').removeClass('active');
            $('[data-nsf-parent-menu="' + menu + '"]').addClass('active');
        });

        $('[data-nsf-menu].has_menu_items a').on('click', function (e) {
            e.preventDefault();
        });
    }
}

var nsfMobileSubscribe = {
    init: function () {
        this._bindClosePopupEvent();
        this._showPopup();
        this._bindFormSubmitEvent();
    },

    _showPopup: function () {
        if (this._canShowPopup()) {
            $('[data-nsf="mobile-subscribe"]').addClass('active');
        }
    },
    
    _canShowPopup: function () {
        return $.cookie('nsf_mobile_subscribe_popup') === undefined;
    },

    _bindClosePopupEvent: function () {
        $('[data-nsf="close-subscribe"]').on('click', function () {
            $('[data-nsf="mobile-subscribe"]').removeClass('active');
            $.cookie('nsf_mobile_subscribe_popup', 1, {expires: 3, path: '/'});
        });
    },

    _bindFormSubmitEvent: function () {
        $('[data-nsf="mobile-subscribe"] input[type="submit"]').on('click', function () {
            $.cookie('nsf_mobile_subscribe_popup', 1, {expires: 3, path: '/'});
        });
    }
};

var nsfSpecialOffers = {
    init: function () {
        let self = this;

        let mo = new MutationObserver(function (mutations) {
            mutations.forEach(function (m) {
                self._buildDiscountDetailsHtml();
            })
        })

        let $summaryWrapper = $('.saso-summary');
        if ($summaryWrapper.length >= 1) {
            mo.observe($summaryWrapper[0], {
                childList: true
            })
        }
    },

    _buildDiscountDetailsHtml: function () {
        if (window.saso === undefined
            || window.saso.page_actions_data === undefined
            || window.saso.page_actions_data.discounts === undefined) {
            return
        }

        let discounts = window.saso.page_actions_data.discounts;
        let discountTotal = 0;

        let summaryHtml = '';
        let detailsHtml = '<ul class="discount-details">';

        if (discounts.cart !== undefined
            && discounts.cart.items !== undefined) {

            let actDiscountTotal = 0;
            for (let item of discounts.cart.items) {
                let productTitle = '';
                if (item.hasOwnProperty('title')) {
                    productTitle = item.title;
                }

                if (!item.hasOwnProperty('original_line_price')
                    || !item.hasOwnProperty('discounted_line_price')) {
                    continue;
                }
                let itemDiscountTotal = (item.original_line_price - item.discounted_line_price).toFixed(2);
                discountTotal += parseFloat(itemDiscountTotal);
                actDiscountTotal += parseFloat(itemDiscountTotal);
            }

            if (actDiscountTotal > 0) {
                detailsHtml += '<li class="discount-item">';
                detailsHtml += '<span class="label">Activity Discount Total</span><span class="discount-total">-$' + actDiscountTotal + '</span>';
                detailsHtml += '</li>';
            }
        }

        let discountCode = $.cookie('saso_discount_code')
        if (typeof discounts.cart_discount_amount_html === "string"
            && discountCode !== null && discountCode !== undefined && discountCode.length > 0) {
            discountTotal += parseFloat(discounts.cart_discount_amount.toFixed(2));
            detailsHtml += '<li class="discount-item">'
                + '<span class="label">Discount Code (<strong>'+ discountCode +'</strong>)</span><span class="discount-total">-' + discounts.cart_discount_amount_html + '</span>'
                + '</li>'
        }

        detailsHtml += '</ul>';
        summaryHtml += '<div class="discount-summary"><span class="label">Discount Total</span><span class="discount-total">-$' + discountTotal + '</span></div>';

        let $wrapper = $('[data-nsf="saso-discount-details"]');
        $wrapper.html(summaryHtml + detailsHtml);
        $wrapper.find('.discount-summary').on('click', function () {
            $(this).closest('[data-nsf="saso-discount-details"]').toggleClass('active');
        })
    }
};

$(document).ready(function () {
    nsfCommon.init();
    headerSearch.init();
    nsfSizeChart.init();
    nsfProductGrid.init();
    nsfProductGallery.init();
    nsfShoppingCart.init();
    nsfModal.init();
    nsfQuickShop.init();
    nsfMobileMenu.init();
    nsfMobileSubscribe.init();
    nsfSpecialOffers.init();
});